tpj(function () {

    initFeaturedHotel();
    
});

function initFeaturedHotel() {
    tpj('.featured-hotel').each(function (index) {

        var _this = tpj(this);

        var thumbs1 = _this.find(".thumbnail-slider");
        var thumbs2 = _this.find(".thumbs2");
        var closeBtn = _this.find(".closeBtn");
        var slidePrev = _this.find(".slider-prevContainer");
        var outSliderPrev = _this.find('.thumbnail-slider-prev');
        var outSliderNext = _this.find('.thumbnail-slider-next');
        var slideNext = _this.find(".slider-nextContainer");
        var slides = thumbs1.find("li");
        for (var i = 0; i < slides.length; i++) {
            slides[i].index = i;
            slides[i].onclick = function (e) {
                var li = this;
                var clickedEnlargeBtn = false;
                if (e.offsetX > 220 && e.offsetY < 25) clickedEnlargeBtn = true;
                if (li.className.indexOf("active") != -1 || clickedEnlargeBtn) {
                    thumbs2.css('display', "block");
                    thumbs2list[index].init(li.index);
                }
            };
        }

        slideNext.click(function () {
            thumbs2list[index].next();
        });
        slidePrev.click(function () {
            thumbs2list[index].prev();
        });
        outSliderNext.click(function () {
            sliderslist[index].next();
        });
        outSliderPrev.click(function () {
            sliderslist[index].prev();
        });
        closeBtn.click(function () {
            thumbs2.fadeOut();
        });
        thumbs2.click(function (e) {
            var container = tpj(this).find('.inner');

            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0) // ... nor a descendant of the container
            {
                thumbs2.fadeOut();
            }

        });

    });

    tpj('.collapsibleList label').on('click', function () {
        tpj(this).parent().nextAll().slideToggle();
    })
}

function showHotelTabs(id) {
    if (tpj('#HotelTabs-' + id).is(':hidden')) {

        tpj('body,html').animate({
            scrollTop: tpj('#HotelTabs-' + id).parent().next('.price').eq(0).offset().top - 100
        }, 800);

        tpj('#HotelTabs-' + id).prev('.bg-holder').eq(0).removeClass('bg-holder-shadow-removed').addClass('bg-holder-shadow');
        tpj('#HotelTabs-' + id).slideDown(500);

    } else {

        tpj('body,html').animate({
            scrollTop: tpj('#HotelTabs-' + id).parent().offset().top - 50
        }, 800);

        tpj('#HotelTabs-' + id).prev('.bg-holder').eq(0).addClass('bg-holder-shadow-removed').removeClass('bg-holder-shadow');
        tpj('#HotelTabs-' + id).slideUp(500);

    }
}